<header class="header-style-1">
  <div class="top-bar animate-dropdown">
    <div class="container">
      <div class="header-top-inner">
        <div class="cnt-account">
          <div class="cnt-inner">
            <ul class="list-unstyled" id="list1">
              <li id="headermsg">{{headermsg}}</li>
            </ul>
            <ul class="list-unstyled">

              <li id="phone"
                *ngIf="(Secondcontact==null || Secondcontact==undefined || Secondcontact.cPhone==null || Secondcontact.cPhone==undefined || Secondcontact.cPhone=='') && (contactDtl!=null && contactDtl!=undefined && contactDtl.phone!=null && contactDtl.phone!=undefined && contactDtl.phone!='') ">
                <a href="tel:{{contactDtl.phone}}"><i class="icon fa fa-phone"></i> {{contactDtl.phone | phone:'US' }}</a>
              </li>
              <li id="phone1"
                *ngIf="Secondcontact!=null && Secondcontact!=undefined && Secondcontact.cPhone!=null && Secondcontact.cPhone!=undefined && Secondcontact.cPhone!=''">
                <a href="tel:{{contactDtl.cPhone}}"><i class="icon fa fa-phone"></i> {{Secondcontact.cPhone | phone:'US' }}</a>
            </li>
            <li *ngIf="webtype != '1'" id="MyCart">
              <a [routerLink]="['/viewcart']">
                <i class="icon fa fa-shopping-cart"></i>My Cart</a>
            </li>            
            
            <li *ngIf="webtype != '1' && iswishshow=='1' && isNotLoggedIn==false">              
              <a [routerLink]="['/wish']">
                <i class="fa fa-list-alt" aria-hidden="true"></i> {{wishlistlable}}</a> 
            </li>
            <li *ngIf="!isDisableElem && (IsPunchOut=='no' || IsPunchOut==undefined)">
              <a [class.disabled] = "isDisableElem === true" [routerLink]="['/dashboard']">
                  <i class="icon fa fa-user "></i> My Account
                </a>
            </li>
            <li *ngIf="isNotLoggedIn==false && IsPunchOut=='Yes' && iskinter=='KINTER'">
              <a  [routerLink]="['/kinterdashboard']">
                  <i class="icon fa fa-user "></i> Punchout Home
                </a>
            </li>
            <li *ngIf="webtype != '1' && isrfqshow=='1' && isNotLoggedIn==false">              
              <a (click)="gotorfqpage()" class="cpointer">
                <i class="fa fa-list-ul" aria-hidden="true"></i> RFQ List</a>
            </li>
            <li *ngIf="webtype != '1' && IsRMA=='1' && isNotLoggedIn==false">              
              <a (click)="gotormapage()" class="cpointer">
                <i class="fa fa-list-ul" aria-hidden="true"></i> {{RMALable}}</a>
            </li>
            <li *ngIf="isNotLoggedIn && !isDisableElem" class="cpointer">
              <a (click)="logClick()">
                <i class="icon fa fa-lock"></i> Login
              </a>
            </li>
            <li *ngIf="isNotLoggedIn==false && !isDisableElem" class="cpointer">
              <a (click)="logout()" >
                  <i class="icon fa fa-lock"></i> Logout
                </a>
              </li>
              <li *ngIf="isNotLoggedIn==false && user!='' && !isDisableElem" class="cpointer">
                <a [routerLink]="['/dashboard']">
                  <i class="icon fa fa-user "></i> {{user}}
                </a>
              </li>
              <li *ngIf="isNotLoggedIn==false && user!='' && isDisableElem" class="cpointer">
                <a class="cpointer" (click)="gotosouthern()">
                  <i class="icon fa fa-user "></i> {{user}}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>

    </div>

  </div>
  
  <div class="headerimg" *ngIf="isheaderbanner==1">
    <img src="https://portal3.distone.com/xponential/assets/images/banner_logo2.png">
  </div>

  <div class="main-header">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3 logo-holder">
          <div class="logo" *ngIf="!isDisableElem">
            <a [routerLink]="[logourl]" *ngIf="logourl!=undefined && logourl.indexOf('http')==-1">
              <img src="{{logoimageurl}}" alt="{{webname}}">
            </a>
            <a href="{{logourl}}" *ngIf="logourl!=undefined && logourl.indexOf('http')>-1">
              <img src="{{logoimageurl}}" alt="{{webname}}">
            </a>
          </div>
          <div class="logo" *ngIf="isDisableElem">
            <a class="cpointer" (click)="gotosouthern()">
              <img src="{{logoimageurl}}" alt="{{webname}}">
            </a>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 top-search-holder divcenter" *ngIf="webtype != '1'">
          <div class="search-area" *ngIf="!isDisableElem">
            
            <input [(ngModel)]="asyncSelected"
            type="search"
            id="searchcontrol"
           [typeahead]="dataSource"
           [typeaheadScrollable]="true"
           [typeaheadAsync]="true"
           [typeaheadSelectFirstItem]="false"
           (typeaheadOnSelect)="typeaheadOnSelect($event)"
           (keyup.enter)="selectProductNew($event)" 
           [typeaheadOptionsLimit]="10"
           [typeaheadOptionField]="itemname"
           [typeaheadIsFirstItemActive]="false"           
           [typeaheadItemTemplate]="customItemTemplate"
           placeholder="{{Searchplaceholder}}"
           
           class="form-control clearable">
           
           <ng-template #customItemTemplate let-model="item" class="itemmenu" let-index="index">
            <a (click)='clearsearchtext(model)' class="menuhover cpointer">
                <div style="float: left;">
                  <img  src="{{model.image}}" alt="{{model.itemname}}" class="fixwidthimg35"/>
                </div>
                <div style="margin-left: 50px;">
                  <label>{{model.itemname}}</label><br>
                  
                  <span *ngIf="isdescron=='1'">{{model.description1 | keys}}</span>
                  <span *ngIf="isdescron=='0'">{{model.freeform}}</span>
                </div>
              
          </a>
          </ng-template>
           
            <form>
              <div class="control-group">
              </div>
            </form>
          </div>
          </div>
        <div class="col-xs-12 col-sm-12 col-md-3 animate-dropdown top-cart-row divcenter" *ngIf="webtype!='1'">
          <div *ngIf="istranslate==1" id="google_translate_element"></div>
          <div class="dropdown dropdown-cart"> <a href="#" class="dropdown-toggle lnk-cart" data-toggle="dropdown">
              <div class="items-cart-inner">
                <div class="basket"> <i class="glyphicon glyphicon-shopping-cart"></i> </div>
                <div class="basket-item-count"><span class="count">{{numProducts}}</span></div>
                <div class="total-price-basket"> <span class="lbl">cart </span> <span class="total-price"
                    *ngIf="cartTotal!=undefined && israteshowforcu==true && priceshowcust=='1'"> - ${{cartTotal |
                    million}} </span> </div>
              </div>
            </a>
            <ul class="dropdown-menu" style="max-height: 500px;overflow:hidden;overflow-y: auto;"
              *ngIf="products.length > 0">
              <li>

                <a [routerLink]="['/viewcart']" class="btn btn-upper btn-primary btn-block viewcart">View Cart</a>
                <br />
                <div class="cart-item product-summary">
                  <div *ngFor="let item of products">
                    <div class="row">
                      <div class="col-xs-4">
                        <div class="image">
                          <a [routerLink]="['/productdetail',item.product.itemname.toLowerCase(),item.product.links.toLowerCase()]"
                            class="cpointer">
                            <img class="cart5050px" src="../assets/images/Product.png"
                              alt="{{item.product.itemname+'' + item.product.descr1+'' + item.product.freeform}}"
                              *ngIf="item.product.image == 'NotFound'">
                            <img class="cart5050px" src="{{item.product.image}}"
                              alt="{{item.product.itemname +''+ item.product.descr1 +''+ item.product.freeform}}"
                              *ngIf="item.product.image != undefined">
                          </a>
                        </div>
                      </div>
                      <div class="col-xs-7">
                        <a [routerLink]="['/productdetail',item.product.itemname.toLowerCase(),item.product.links.toLowerCase()]"
                          class="cpointer">
                          <h3 class="name">
                            {{item.product.itemname}}
                          </h3>
                          <p>
                            Qty : {{item.quantity}}
                          </p>
                          <div class="price" *ngIf="israteshowforcu==true && priceshowcust=='1'">
                            ${{item.product.parsedPrice | million }} </div>
                          <div class="price">{{getumdescbyumcode(item.product.um)}}</div>
                        </a>
                      </div>
                      <div class="col-xs-1 action">
                        <a class="cpointer" (click)='deleteProduct(item.product)'>
                          <i class="fa fa-trash"></i>
                        </a>
                      </div>
                      <hr>
                    </div>
                    <hr>
                  </div>
                </div>
                <div class="clearfix cart-total" *ngIf="products.length>4">
                  <div class="pull-right" *ngIf="israteshowforcu==true && priceshowcust=='1'">
                    <span class="text">Sub Total :</span>
                    <span class='price'>${{cartTotal | million}}</span>
                  </div>
                  <div class="clearfix"></div>
                  <a [routerLink]="['/viewcart']" class="btn btn-upper btn-primary btn-block m-t-20">View Cart</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="header-nav animate-dropdown">
    <div class="container">
      <div class="yamm navbar navbar-default" role="navigation">
        <div class="navbar-header">
          <button data-target="#mc-horizontal-menu-collapse" data-toggle="collapse" class="navbar-toggle collapsed"
            type="button">
            <span class="sr-only">Toggle navigation</span>
            <span id="mobilemenu1" class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="nav-bg-class">
          <div class="navbar-collapse collapse" id="mc-horizontal-menu-collapse">
            <div class="nav-outer">
              <ul class="nav navbar-nav" (click)="closemobilemenu1()" *ngIf="headerlinks!=undefined && headerlinks.length > 0 && !isDisableElem">
                  <li [ngClass]="{'Menuactive': isactive==hlink.linkname}" *ngFor="let hlink of headerlinks">                    
                      <a [routerLink]="[hlink.linkurl]" *ngIf="hlink.popover && hlink.linkurl.indexOf('http')==-1" target="_blank" (click)="SetActiveTab(hlink.linkname)">{{hlink.linkname}} </a>
                      <a href="{{hlink.linkurl}}" *ngIf="hlink.popover && hlink.linkurl.indexOf('http')>-1" target="_blank" (click)="SetActiveTab(hlink.linkname)">{{hlink.linkname}} </a>
                      <a [routerLink]="[hlink.linkurl]" *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')==-1" (click)="SetActiveTab(hlink.linkname)">{{hlink.linkname}}</a>
                      <a href="{{hlink.linkurl}}" *ngIf="!hlink.popover && hlink.linkurl.indexOf('http')>-1" (click)="SetActiveTab(hlink.linkname)">{{hlink.linkname}}</a>
                    </li> 
                    <!--<li *ngIf="!isDisableElem && (IsPunchOut=='no' || IsPunchOut==undefined)" [ngClass]="{'Menuactive': isactive=='/dashboard'}">
                      <a  [routerLink]="['/dashboard']" (click)="SetActiveTab('/dashboard')">
                          My Account
                        </a>
                    </li>-->
                    <li *ngIf="isNotLoggedIn==false && IsPunchOut=='Yes' && iskinter=='KINTER'" [ngClass]="{'Menuactive': isactive=='/kinterdashboard'}">
                      <a  [routerLink]="['/kinterdashboard']" (click)="SetActiveTab('/kinterdashboard')">
                          Punchout Home
                        </a>
                    </li>
                    <li id="liRegister" class="fright" *ngIf="isNotLoggedIn && webtype != '1' && isShowRegistration" [ngClass]="{'Menuactive': isactive=='Register'}">
                      <a (click)="register()">Register</a>
                    </li>
                    <li id="liSalesLogin" class="fright" *ngIf="isNotLoggedIn && webtype=='6' && isShowSalesLogin=='1'" [ngClass]="{'Menuactive': isactive=='SLogin'}">
                      <a (click)="slogClick()" >Sales Login</a>
                    </li>
                    <li id="liLogin" class="fright" *ngIf="isNotLoggedIn" [ngClass]="{'Menuactive': isactive=='Login'}">
                      <a  (click)="logClick()" >Login</a>
                    </li>
                    <li id="liLogOut" class="fright cpointer" *ngIf="isNotLoggedIn==false">
                      <a (click)="logout()">Logout</a>
                    </li>
              </ul>
              <ul class="nav navbar-nav" *ngIf="isDisableElem">
                  <li>
                    <a class="cpointer" (click)="gotosouthern()">Home</a>
                  </li>
              </ul>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>